export default __webpack_public_path__ + "static/media/text-icon-instruction-new.8ea362c5.svg";